import { useEffect } from "react";
import { pushBookingEvent } from "@/lib/analytics";
import ThankYou from "@/components/pages/thank-you/ThankYou";
import ContactSection from "@/components/pages/thank-you/ContactSection";
import { CALENDAR_URLS } from "@/lib/constants";

const ConsultationThankYou = () => {
  useEffect(() => {
    // Track successful booking
    pushBookingEvent({
      bookingType: "consultation",
      eventCategory: "Booking",
      eventAction: "Success",
      eventLabel: CALENDAR_URLS.consultation,
    });
  }, []);

  return (
    <ThankYou
      title="Thanks for Booking a Free Call!"
      description="Thank you for booking a consultation call with Niumora."
      mainContent={
        <div className="space-y-4">
          <p className="text-lg">
            You should receive a confirmation email shortly. Please check your spam folder if you don't see it in your inbox.
          </p>
          <p className="text-muted-foreground">
            <strong>Important:</strong> You must confirm your booking through the email link, or your session won't be scheduled.
          </p>
        </div>
      }
      additionalContent={
        <div className="space-y-4 text-center">
          <ContactSection />
        </div>
      }
    />
  );
};

export default ConsultationThankYou;
